import {createSlice} from '@reduxjs/toolkit'
import {ROUTE_PATH} from "../../app/constants"

const confirmApplicationSubmissionInitState = () => ({
    header : "Application submitted",
    subHeader : "Next step",
    text : [
        "Your application was submitted to Business Licensing. Before your licence can be processed, you need to submit an original surety bond for $20,000 by mail."
    ],
    navigation : {
        next : ROUTE_PATH.WELCOME
    }
})

const confirmApplicationSubmissionSlice = createSlice({
    name : 'confirmApplicationSubmission',
    initialState : confirmApplicationSubmissionInitState(),
    reducers : {

    }
})

export default confirmApplicationSubmissionSlice.reducer
